import React, { useContext, useEffect } from 'react';
import {
  ComponentFactory,
  ComponentParams,
  ComponentRendering,
  Field,
  RichText,
  SitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';
import { useLocation } from 'react-router-dom';
import { APIWebstoreContext } from '../../context/globalContext';

export type PaymentConfirmationProps = {
  fields: {
    ConfirmationText: Field<string>;
    Title: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

interface Props {
  children: React.ReactElement;
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
}

const PaymentConfirmation = (props: PaymentConfirmationProps & Props): React.JSX.Element => {
  const { fields } = props;
  const { state } = useContext(APIWebstoreContext);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const invoiceNumber = searchParams.get('invoiceNumber') || '';

  function replaceText(): Field<string> {
    let confirmationText = fields.ConfirmationText.value;
    confirmationText = confirmationText.replace('##EMAIL_ID##', state?.userEmail || '');
    confirmationText = confirmationText.replace('##INVOICE_NUMBER##', invoiceNumber);
    fields.ConfirmationText.value = confirmationText;
    return fields.ConfirmationText;
  }

  return (
    <div className="paymentCenterContainer">
      <div className="paymentConfirmationSection">
        <div className="paymentConfirmationHeader">
          <h1>{fields?.Title?.value}</h1>
        </div>

        <div className="paymentConfirmationContent">
          <RichText className="paymentConfirmationRichText" field={replaceText()} />
        </div>
      </div>
    </div>
  );
};

export default PaymentConfirmation;
